import { render, staticRenderFns } from "./UDIOutlistChildNew.vue?vue&type=template&id=2a7f7d75&scoped=true"
import script from "./UDIOutlistChildNew.vue?vue&type=script&lang=js"
export * from "./UDIOutlistChildNew.vue?vue&type=script&lang=js"
import style0 from "./UDIOutlistChildNew.vue?vue&type=style&index=0&id=2a7f7d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f7d75",
  null
  
)

export default component.exports